// extracted by mini-css-extract-plugin
export var underlinedLink = "_sq-0";